/**
 * 로그인 화면 헤드라인에서 순환하는 단어들.
 *
 * 글로릴스는 15개 언어 인사를 순환시켜 "내 릴스가 모든 언어로 말한다"는
 * 브랜드 약속을 첫 화면에서 보여준다. 소듀는 그 **형태(순환하는 대형 헤드라인)** 만
 * 가져오고 내용은 소듀가 실제로 하는 일로 채운다.
 *
 * ⚠️ 아래 문구는 코드베이스에서 확인되는 기능 영역으로 채운 **임시안**이다.
 *    최종 카피가 정해지면 이 배열만 교체하면 된다.
 */
export const HEADLINE_WORDS = [
    '프로필링크',
    '공동구매',
    '라이브',
    '상품 소싱',
    '주문·정산',
] as const;

/** 순환 단어 뒤에 고정으로 붙는 문장 */
export const HEADLINE_SUFFIX = '하나의 계정으로.';
